import { Outlet, Link } from '@tanstack/react-router';
import { Container } from '@/components/ui/container';
import { ThemeToggle } from '@/components/ui/theme-toggle';

/** Centered single-column chrome for auth + onboarding steps. */
export function AuthLayout() {
  return (
    <div className="flex min-h-dvh flex-col overflow-x-clip">
      <header className="flex h-16 items-center justify-between px-6">
        <Link to="/" className="flex items-center gap-2 font-display font-semibold">
          <span className="rounded-blob inline-block size-4 bg-accent" aria-hidden />
          Nearmirer
        </Link>
        <ThemeToggle />
      </header>
      <main className="flex flex-1 items-center justify-center py-10">
        <Container className="max-w-md">
          <Outlet />
        </Container>
      </main>
    </div>
  );
}
